<template>
    <div class="box-wrap active-box-wrap" :style="boxWrapStyleObj">
        <span class="border-left-top"></span>
        <span class="border-left-bottom"></span>
        <span class="border-right-top"></span>
        <span class="border-right-bottom"></span>
        <div
                class="statis-title bg1"
                style="display: flex; justify-content: center"
                :ref="`${activeType}_statisTitle`"
        >
      <span>{{ title }}</span
      ><span class="split-line">|</span>
            <div class="active-statis">
                <Select
                        v-model="timeSolt"
                        ref="timeIntervalSelectRef"
                        placeholder="全部时段"
                        @on-change="changeTimeSolt($event)"
                >
                    <Option value="1">近1个月</Option>
                    <Option value="3">近3个月</Option>
                    <Option value="6">近6个月</Option>
                </Select>
            </div>
            <span class="active-box-more-txt click-element" @click="lookMoreData">
        更多
        <i></i>
      </span>
        </div>
        <!-- 教师活跃情况 -->
        <div :style="{ height: contentStyleObj.height }">
            <div style="width: 100%; height: 100%"
                 id="tea-active-detail"
                 v-show="!isShow"
            ></div>
            <div class="chart-error" v-show="isShow" style="padding-top: 100px;">
                <div class="detail">
                    <span class="detail">暂无数据</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {fetchTeacherActiveData} from "../../../service/bigDataApi.js";

    export default {
        name: "active-teacher-statics",
        data() {
            return {
                screenWidth: 0, //屏幕宽度
                boxWrapStyleObj: {
                    height: "",
                },
                contentStyleObj: {
                    height: "",
                },
                styleObj: {
                    width: "100%",
                    height: "100%",
                },
                timeSolt: "1",
                startDate: "",
                endDate: "",
                title: "教师活跃情况",
                activeType: "teacher",
                isShow: false,
            };
        },
        props: {
            screenHeight: Number,
            titleHeight: Number,
            schoolId: String,
            schoolName: String,
            schoolCode: String,
        },
        watch: {
            screenHeight: "initBoxHeight",
            titleHeight: "initBoxHeight",
        },
        methods: {
            /**
             * 初始化box高度
             */
            initBoxHeight() {
                let titleRef = this.activeType + "_statisTitle";
                let winHeight = window.innerHeight;
                if (winHeight < 900) {
                    winHeight = 938;
                }
                let boxWrapHeight = (winHeight - 128 - 10 - 30) / 3;
                let contentHeight =
                    boxWrapHeight - this.$refs[titleRef].offsetHeight - 20;
                this.boxWrapStyleObj.height = boxWrapHeight + "px";
                this.contentStyleObj.height = contentHeight + "px";
            },
            /**
             * 获取教师活跃情况
             */
            async getTeacherActiveData() {
                let _this = this;
                let param = {
                    schoolId: this.schoolId,
                    startTime: this.startDate,
                    endTime: this.endDate,
                };
                await fetchTeacherActiveData(param)
                    .then(function (data) {
                        let dataArr = [];
                        let numArr = [];
                        for (let i = 0; i < data.length; i++) {
                            dataArr.push(data[i].format_stats_date);
                            numArr.push(data[i].operation_count);
                        }
                        _this.$nextTick(() => {
                            _this.initDataSource(data, dataArr, numArr);
                        });
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 初始化折线图
             */
            initDataSource(curResultData, dateArr, numberArr) {
                let _this = this;
                let dataSource = _this.$echarts.init(
                    document.getElementById("tea-active-detail")
                );
                _this.isShow = curResultData.length <= 0;
                const option = {
                    tooltip: {
                        //数据悬浮
                        trigger: "axis",
                        //自定义悬浮框内容
                        formatter: function (params) {
                            var color = "#4A5E8F"; //图例颜色
                            var htmlStr = "<div>";
                            htmlStr += params[0].name + "<br/>"; //x轴的名称
                            //添加圆点
                            htmlStr +=
                                '<span style="margin-right:5px;display:inline-block;width:10px;height:10px;border-radius:5px;background-color:' +
                                color +
                                ';"></span>';
                            //添加一个汉字，格式化自定义文本内容
                            htmlStr += "使用：" + params[0].value + "次";
                            htmlStr += "</div>";
                            return htmlStr;
                        },
                    },
                    xAxis: {
                        type: "category",
                        boundaryGap: false,
                        data: dateArr,
                        axisLine: {
                            lineStyle: {
                                color: "#4A5E8F",
                            },
                        },
                        axisLabel: {
                            textStyle: {
                                fontSize: "12px",
                            },
                        },
                    },
                    yAxis: {
                        type: "value",
                        axisLabel: {
                            textStyle: {
                                fontSize: "12px",
                            },
                            formatter: "{value}",
                        },
                        splitLine: {
                            show: false,
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#4A5E8F",
                            },
                        }
                    },
                    grid:{
                        top:"5%",
                        bottom:"10%"
                    },
                    series: [
                        {
                            type: "line",
                            smooth: true,
                            symbol: "circle", // 设置标记的图形为circl
                            symbolSize:12,
                            color:'#0a7cd1',
                            itemStyle: {
                                normal: {
                                    borderColor: "#10E0E9",  // 点边框的颜色
                                    borderWidth:2,
                                    lineStyle: {
                                        width: 0.5
                                    },
                                },
                            },
                            areaStyle: {
                                normal: {
                                    // 填充色渐变
                                    color: new _this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                        { offset: 0, color: "#0a7cd1" },
                                        { offset: 0.5, color: "#0a7cd1" },
                                        { offset: 1, color: "rgba(10,124,209,0)" }
                                    ])
                                }
                            },
                            data: numberArr,
                        },
                    ],
                };
                dataSource.setOption(option);
                window.addEventListener("resize", function () {
                    dataSource.resize();
                });
            },
            /**
             * 选择时间段
             */
            changeTimeSolt(type) {
                this.timeSolt = type;
                let todayStr = this.$utils.getYestodaySevenDayStr(1);
                this.endDate = todayStr;
                this.startDate = this.$utils.getPreMonthDay(todayStr, this.timeSolt);
                this.getTeacherActiveData();
            },
            /**
             * 查看更多数据信息
             */
            lookMoreData() {
                let routeData = this.$router.resolve({
                    name: "actstatisdetails",
                    query: {
                        schoolId: this.schoolId,
                        schoolName: this.schoolName,
                        schoolCode: this.schoolCode,
                        activeType: this.activeType,
                        tabCode: 'resTab',
                        activeTypeName: "教师活跃情况",
                    },
                });
                window.open(routeData.href, "_blank");
            },
        },
        mounted() {
            this.changeTimeSolt("1");
        },
    };
</script>

<style lang="scss" scoped>
    @import "../../../style/databoard";
    @import "../../../style/layout";

    .bg1 {
        background-image: url("../../../assets/images/databoard/title-bg3.png");
    }

    .active-static-tab-item {
        background-image: url("../../../assets/images/databoard/icon_tab_normal.png");
    }

    .active-static-tab-item-selected {
        background-image: url("../../../assets/images/databoard/icon_tab_hover.png");
    }

    .active-box-more-txt i {
        background-image: url(../../../assets/images/databoard/active-icon.png);
        background-position: -299px 90px;
    }

    .active-static-icon-arrow-down {
        background-image: url(../../../assets/images/databoard/active-icon.png);
        background-position: -224px 90px;
    }
</style>

<style lang="scss">
    .active-statis {
        .ivu-select-selection {
            box-shadow: transparent !important;
            background-color: transparent !important;
            border: transparent !important;
        }
        .ivu-select-single .ivu-select-selection .ivu-select-placeholder,
        .ivu-select-single .ivu-select-selection .ivu-select-selected-value {
            font-size: 16px !important;
            color: #0efcff !important;
        }
        .ivu-select-arrow {
            color: #0efcff !important;
        }

        .ivu-select-dropdown {
            max-height: 100px;
            background: rgba(10, 18, 39, 0.97);
            box-shadow: inset 0px 0px 10px 4px rgba(14, 252, 255, 0.15) !important;
            border-radius: 5px;
        }
        .ivu-select-item {
            color: #0efcff !important;
            text-align: center;
        }

        .ivu-select-item:hover {
            background: #0efcff !important;
            color: #0a1227 !important;
        }

        .ivu-select-item-focus {
            background: #0efcff !important;
            color: #0a1227 !important;
        }
    }
</style>
